import $ from 'jquery';
import VariantHelper from '../utils/VariantHelper';
import Select from '../components/Select';
import Rte from '../utils/Rte';
import ProductGallery from '../components/ProductGallery';

function updateCart() {
  window.Shopify.getCart((cart) => {
    const newFormattedAmount = window
      .Shopify
      .formatMoney(cart.total_price, window.Theme.moneyFormat);

    // Update cart text
    $('.cart-item-count-wrap').text(`(${cart.item_count})`);
    $('.cart-amount-wrap').html(newFormattedAmount);
  });
}

export default class Product {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.product = this.data.product;

    this.addingToCart = false;

    this.$productArea = $('.product-page', this.el);
    this.$productForm = $('.product-form', this.$productArea).eq(0);
    this.$priceArea = $('.product-price', this.$productForm);
    this.$addToCartButton = $('.product-add input', this.$productForm);
    this.$variantDropdowns = $('[data-option-select]', this.$productForm);

    this.options = this.product.options;
    this.variants = this.product.variants;
    this.gallery = new ProductGallery(this.el.querySelector('[data-product-gallery]'), {
      enable_image_zoom: this.data.gallery_image_zoom,
      enable_video_autoplay: this.data.gallery_video_autoplay,
      enable_video_looping: this.data.gallery_video_looping
    });

    if ($('.product-form', this.el).length) {
      this.setupVariants();
    }

    $('select', this.el).each((index, select) => new Select({ el: select }));
    $('.rte', this.el).each((index, rte) => new Rte({ el: rte }));
    this.$productForm.on('variant-helper:variant-change', (event, data) => {
      this.gallery.selectMediaByVariant(data.variant);
    });

    window.Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
    this.$addToCartButton.on('click.product', event => this.addToCart(event));
  }

  setupVariants() {
    if (!this.$variantDropdowns.length) { return; }

    const dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $selector: this.$variantDropdowns,
      productSettings: this.data,
      productJSON: this.product,
      type: 'select',
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
  }

  addToCart(e) {
    if (this.data.enable_cart_redirection) {
      return;
    }

    e.preventDefault();

    $('.product-message-wrapper', this.el).remove();
    if ((this.addingToCart === true) || (this.$productForm.serialize() === '')) {
      return;
    }

    const $button = $('.product-add .action-btn', this.el);

    if (!$button.hasClass('disabled')) {
      this.addingToCart = true;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: this.$productForm.serialize(),
        dataType: 'json',
        success: () => {
          const message = this.data.atc_message_success
            .replace('{{ product }}', `${this.product.title}`)
            .replace('{{ cart_link }}', `<a href="${window.Theme.routes.cart_url}">${this.data.atc_cart_link}</a>`)
            .replace('{{ continue_link }}', `<a href="${window.Theme.routes.all_products_collection_url}">${this.data.atc_continue_shopping}</a>`)
            .replace('{{ checkout_link }}', `<form class="product-message__form" action="${window.Theme.routes.cart_url}" method="POST"><button class="product-message__btn" type="submit" name="checkout">${this.data.atc_checkout_link}</button></form>`);

          setTimeout(() => {
            $('.product-add-to-cart', this.el).append(`
                <li class="product-message-wrapper"><div class="product-message">${message}</div></li>
              `)
              .addClass('success-message').removeClass('error-message');
            this.addingToCart = false;
            updateCart();
          },
          500);
        },
        error: error => this.handleErrors(error),
      });
    }
  }

  handleErrors(error) {
    setTimeout(() => {
      $('.product-add-to-cart', this.el)
        .append(`
          <li class="product-message-wrapper">
              <p class="product-message">
                  ${error.responseJSON.description}
              </p>
          </li>
        `)
        .addClass('error-message')
        .removeClass('success-message');
      this.addingToCart = false;
    },
    1000);
  }

  onSectionUnload() {
    this.$addToCartButton.off('click.product');
  }
}
